<template>
  <router-view/>
</template>
<script>
    export default {
    name: 'impugnacionIndex'
    }
</script>

<style scoped>

</style>
